import { useMemo, useState } from 'react';
import { MAutoComplete, MButton, MInput, TabButton } from '@Components/Base';
import { Divider, Flex, Modal, Row, Typography } from 'antd';

import { parseDateTime } from '@Utils/transformDateTime';
import { User } from '@Types/index';
import { transformUserOptions } from '@Utils/transformUserOptions';
import { DefaultOptionType } from 'antd/es/select';

import styles from './select-employee.module.css';

interface SelectModalEmployeeProps {
  openSelectEmployeeModal: boolean;
  optionUsers: User[];
  currentUser: User | undefined;
  isMyselfUser: boolean;
  handleOk: () => void;
  handleCancel: () => void;
  handleEmployeeTabClick: () => void;
  handleMySelfTabClick: () => void;
  handleSearchEmpByNumber: (empNumber: string) => void;
}

const SelectModalEmployee: React.FC<SelectModalEmployeeProps> = ({
  openSelectEmployeeModal,
  optionUsers,
  currentUser,
  isMyselfUser,
  handleSearchEmpByNumber,
  handleOk,
  handleCancel,
  handleEmployeeTabClick,
  handleMySelfTabClick,
}) => {
  const searchOptions = useMemo(
    () => transformUserOptions(optionUsers),
    [optionUsers]
  );
  const [searchValue, setSearchValue] = useState('');

  const replacementOptions = useMemo(() => {
    const output = searchOptions.filter(
      (option) =>
        option.label.toLowerCase().includes(searchValue.toLocaleLowerCase()) ||
        option.value.toLowerCase().includes(searchValue.toLocaleLowerCase())
    );

    return output;
  }, [searchValue, searchOptions]);

  const onSelect = (data: string, option: DefaultOptionType): void => {
    handleSearchEmpByNumber(String(option?.value));
    setSearchValue('');
  };

  const customButtons = [
    <MButton key="back" type="tertiary" onClick={handleCancel}>
      Cancel
    </MButton>,
    <MButton key="submit" type="primary" onClick={handleOk}>
      Apply
    </MButton>,
  ];

  return (
    <Modal
      className={styles.selectEmployeeModal}
      title="Select Employee"
      open={openSelectEmployeeModal}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={customButtons}
    >
      <Divider />
      <Row style={{ width: '100%', margin: '20px 0px' }}>
        <TabButton>
          <MButton type="text" onClick={handleEmployeeTabClick}>
            Employee
          </MButton>
          <MButton type="text" onClick={handleMySelfTabClick}>
            Myself
          </MButton>
        </TabButton>
      </Row>
      <Flex vertical gap={16}>
        {!isMyselfUser && (
          <div>
            <MAutoComplete
              style={{ width: '100%' }}
              options={replacementOptions}
              onSelect={onSelect}
              onSearch={(searchString) => {
                setSearchValue(searchString);
              }}
              value={searchValue}
            >
              <MInput
                searchInput
                placeholder="Search by employee ID or employee name..."
              />
            </MAutoComplete>
          </div>
        )}
        <div>
          <Typography.Text strong>Employee ID</Typography.Text>
          <MInput
            name="empId"
            placeholder="Insert ID"
            value={currentUser?.empNumber}
          />
        </div>
        <div>
          <Typography.Text strong>Employee Name</Typography.Text>
          <MInput
            name="empNam"
            placeholder="Insert Employee Name"
            value={currentUser?.empName}
          />
        </div>
        <div>
          <Typography.Text strong>Date of Joining</Typography.Text>
          <MInput
            name="dateOfJoining"
            placeholder="DD.MM.YYYY"
            value={parseDateTime(currentUser?.startDate)}
          />
        </div>
        <div>
          <Typography.Text strong>Company</Typography.Text>
          <MInput
            name="company"
            placeholder="Insert Company"
            value={currentUser?.company}
          />
        </div>
        <div>
          <Typography.Text strong>Occupation</Typography.Text>
          <MInput
            name="occupation"
            placeholder="Insert Occupation"
            value={currentUser?.occupation}
          />
        </div>
        <div>
          <Typography.Text strong>Location</Typography.Text>
          <MInput
            name="location"
            placeholder="Insert Location"
            value={currentUser?.currentLocation}
          />
        </div>
      </Flex>
    </Modal>
  );
};
export default SelectModalEmployee;
